import { memo } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { useDispatch, useSelector } from 'react-redux';
import { hideMessage, messageSelector } from 'store/message/messageSlice';
import { Alert } from '@mui/material';

function CustomMessage() {
  const dispatch = useDispatch();
  const messageState = useSelector(messageSelector);
  const { open, options } = messageState;
  const { message } = options;

  return (
    <Snackbar
      {...options}
      open={open}
      onClose={() => dispatch(hideMessage())}
      anchorOrigin={{
        vertical: options.anchorOrigin.vertical,
        horizontal: options.anchorOrigin.horizontal,
      }}
    >
      <Alert
        onClose={() => dispatch(hideMessage())}
        severity={options.variant}
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          boxShadow:
            '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
          '& .MuiAlert-message': {
            padding: 0,
            typography: 'subtitle1',
            overflow: 'hidden',
          },
          '& .MuiAlert-action': {
            padding: 1,
          },
          minHeight: 48,
          height: 'auto',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default memo(CustomMessage);
